import InputTypesEnum from '../../../Enums/InputTypesEnum';
import PlanningExportLevelsEnum from '../../../Enums/PlanningExportLevelsEnum';
import PlanningExportItem from '../../../Domain/PlanningExportItem';
import planningExportDownload from './planningExportDownload';

const OPTIONS_BY_LEVEL = {
  [PlanningExportLevelsEnum.Service]: [
    { value: PlanningExportLevelsEnum.Service, label: 'Service summary (one row per service)' },
    { value: PlanningExportLevelsEnum.Item, label: 'Country rows (one row per country)' },
    { value: PlanningExportLevelsEnum.Detail, label: 'Detail rows (one row per fieldwork period)' },
  ],
  [PlanningExportLevelsEnum.Item]: [
    { value: PlanningExportLevelsEnum.Item, label: 'Country summary (one row per country)' },
    { value: PlanningExportLevelsEnum.Detail, label: 'Detail rows (one row per fieldwork period)' },
  ],
  [PlanningExportLevelsEnum.Detail]: [
    { value: PlanningExportLevelsEnum.Detail, label: 'Detail rows (one row per fieldwork period)' },
  ],
};

export default class PlanningExportWindowDescription {
  static forLevel(level) {
    const options = OPTIONS_BY_LEVEL[level] || OPTIONS_BY_LEVEL[PlanningExportLevelsEnum.Detail];
    return {
      titleForCreate: 'Export to Excel',
      titleForEdit: 'Export to Excel',
      itemType: PlanningExportItem,
      serviceFunction: (item) => planningExportDownload(item),
      waitForResponseOnWait: true, // GeneralEditWizzardBase: wait for the download before closing
      messageOnSuccess: 'Export has been downloaded.', // GeneralEditWizzardBaseFigma success toast
      pagesInGeneralEditWizzard: [
        {
          label: 'Choose export granularity',
          fields: [
            {
              fieldName: 'Granularity',
              label: 'Export level',
              className: 'col-12',
              type: InputTypesEnum.Select,
              // GeneralEditWizzardPage reads selectValues, GeneralEditWizzardPageFigma reads selectvalues
              selectValues: options,
              selectvalues: options,
              validityChecker: () => '', // required by GeneralEditWizzardPage (called unconditionally)
            },
          ],
        },
      ],
    };
  }
}
